import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Eyebrow } from "./Primitives";

export default function MarketStanding({ sessionId }) {
    const [standing, setStanding] = useState(null);

    useEffect(() => {
        if (!sessionId) return;
        let alive = true;
        api.marketStanding(sessionId)
            .then(s => { if (alive && s?.located) setStanding(s); })
            .catch(() => {});
        return () => { alive = false; };
    }, [sessionId]);

    if (!standing) return null;

    return (
        <div className="border border-burgundy/20 bg-cream-soft p-6" data-testid="market-standing">
            <Eyebrow>Your market</Eyebrow>
            <div className="mt-2 font-display text-3xl text-burgundy" data-testid="market-standing-name">
                {standing.metro_short}
            </div>
            <div className="mt-1.5 text-sm text-ink-muted" data-testid="market-standing-rank">
                Currently #{standing.rank} of the {standing.total_markets} market{standing.total_markets === 1 ? "" : "s"} we're tracking · {standing.assessed_members} assessed member{standing.assessed_members === 1 ? "" : "s"}
            </div>

            <div className="mt-5 pt-5 border-t border-burgundy/15 space-y-3">
                <p className="font-display italic text-base text-burgundy leading-snug">
                    We open a market when we can guarantee your match quality.
                </p>
                <p className="text-sm text-ink-muted leading-relaxed">
                    Most platforms launch everywhere at once, then hand you a thin pool of people who aren't right for you. We won't do that.
                </p>
                <p className="text-sm text-ink-muted leading-relaxed">
                    We open markets in order of readiness. When a market reaches enough assessed members for our compatibility model to work properly, it opens — and everyone there is matched at once. Bring people in your city and your market moves up.
                </p>
            </div>
        </div>
    );
}
